import { render, staticRenderFns } from "./PfaUploader.vue?vue&type=template&id=149b3653"
import script from "./PfaUploader.vue?vue&type=script&lang=js"
export * from "./PfaUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports